import { Vector3 } from '../engine/types/Vector3'
import { Quaternion } from '../engine/types/Quaternion'

export class VectorUtils {
  /**
   * Create rotation quaternion from direction and up vectors
   */
  public static lookRotation(direction: Vector3, up: Vector3 = new Vector3(0, 1, 0)): Quaternion {
    // Create normalized direction without modifying original
    const forward = new Vector3(direction.x, direction.y, direction.z).normalize()
    
    // Use our own lookDir method
    return Quaternion.lookDir(forward, up)
  }

  /**
   * Get normal vector perpendicular to given vector
   */
  static getNormal(vector: Vector3, up: Vector3 = new Vector3(0, 1, 0)): Vector3 {
    const normal = new Vector3()
    normal.crossVectors(vector, up).normalize()
    return normal
  }

  /**
   * Get tangent vector along given direction
   */
  static getTangent(direction: Vector3): Vector3 {
    return direction.clone().normalize()
  }

  /**
   * Get binormal vector (cross product of tangent and normal)
   */
  static getBinormal(tangent: Vector3, normal: Vector3): Vector3 {
    const binormal = new Vector3()
    binormal.crossVectors(tangent, normal).normalize()
    return binormal
  }

  /**
   * Get inward normal vector (direction from position towards center)
   */
  static getInwardNormal(position: Vector3, center: Vector3): Vector3 {
    const inward = center.subtract(position).normalize()
    return inward
  }
} 